import * as React from 'react';
import { cn } from '../../lib/utils';

type StatusValue = 'Active' | 'Pending' | 'Completed' | 'Scheduled' | 'Test' | 'Paused';

const STATUS_STYLES: Record<StatusValue, string> = {
  Active: 'text-accent bg-accent-soft',
  Pending: 'text-amber bg-amber-soft',
  Completed: 'text-muted bg-line',
  Scheduled: 'text-violet bg-violet-soft',
  Test: 'text-sky bg-sky-soft',
  Paused: 'text-rose bg-rose-soft',
};

const STATUS_DOTS: Record<StatusValue, string> = {
  Active: 'bg-accent',
  Pending: 'bg-amber',
  Completed: 'bg-faint',
  Scheduled: 'bg-violet',
  Test: 'bg-sky',
  Paused: 'bg-rose',
};

interface StatusPillProps {
  value: StatusValue | string;
}

const toTitleCase = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

export const StatusPill = ({ value }: StatusPillProps) => {
  const normalized = toTitleCase(String(value));
  const knownValue = STATUS_STYLES[normalized as StatusValue]
    ? (normalized as StatusValue)
    : undefined;

  const dot = knownValue ? STATUS_DOTS[knownValue] : 'bg-faint';
  const style = knownValue ? STATUS_STYLES[knownValue] : 'text-muted bg-line';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide',
        style
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', dot)} />
      {normalized}
    </span>
  );
};
